module.exports = __webpack_public_path__ + "img/logo-doen-blue.6cf6596.svg";